import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-ocupacion',
  templateUrl: './ocupacion.component.html',
  styleUrls: ['./ocupacion.component.scss']
})
export class OcupacionComponent implements OnInit {

  jefesala: any[] = [];
  cabecera: any[] = [];
  total_entradas: any[] = [];

  salas = [
    { 'id': '17' , 'nombre': 'Bingo Riscal'},
    { 'id': '20' , 'nombre': 'Bingo Costa Blanca'},
    { 'id': '21' , 'nombre': 'Bingo Navas'},
    { 'id': '22' , 'nombre': 'Bingo Gorrion'},
  ];

  // FECHAS
  date: string = this.user.formatDate(new Date());
  date_desde: string = new Date().toISOString().slice(0, 10);
  date_hasta: string = new Date().toISOString().slice(0, 10);

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    defaultDate : this.date,
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_desde = dateStr
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    defaultDate : this.date,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => { this.date_hasta = dateStr; }
  };

  constructor(
    public rest: RestService,
    public user: UserService) { }

  ngOnInit() {
    this.getData();
   }

  getJefeSalaData() {
    this.rest.getJefeSalaData(this.date_desde, this.date_hasta).subscribe ((data) => {
      if (data['status'] === '200') {
        this.jefesala = data['data'];
      }
    },(error) => this.jefesala = [] );
  }

  getTotalEntradas() {
    this.rest.getTotalEntradas(this.date_desde, this.date_hasta).subscribe( (data) => {
      this.total_entradas = data['data'];
    });
  }

  getKeys() {
    return (this.jefesala && this.jefesala.length > 0) ?  Object.keys(this.jefesala[0]) : [];
  }

  getData() {
    this.getJefeSalaData();
    this.getTotalEntradas();
  }

  editData(data){
    console.log(data);
  }

}
